module.exports = __webpack_public_path__ + "static/media/img_0.7f223647.png";